import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import CloseIcon from "../../Assets/Icons/closeIcon.svg";
import AiTeamDropDown from "../AiTeamDropDown";

export default function AddTechModal({
  open,
  setOpen,
  dropDownOptions,
  modalheading,
  dropdowntext,
  dropdownoptions,
}) {
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-[510px]">
                <div className="bg-white px-5 pb-5 pt-4 sm:p-3 sm:pb-6 sm:px-5 sm:py-5">
                  <div className="sm:flex sm:flex-col">
                    <div className="flex items-center justify-between">
                      <h1 className="text-[1.1rem] font-[500] text-[#111928]">
                        {modalheading}
                      </h1>
                      <img onClick={() => setOpen(false)} className="cursor-pointer" src={CloseIcon} />
                    </div>
                    <div className="flex items-center justify-between mt-6">
                      <AiTeamDropDown
                        width="330px"
                        text={dropdowntext}
                        options={dropdownoptions}
                      />
                      <button className="w-[130px] h-[2.5rem] rounded-[8px] text-[0.90rem] text-white font-[500] border-[1px] border-[#942A27] bg-[#942A27]">
                        Add
                      </button>
                    </div>
                    <div className="mt-4">
                        <p className="text-[0.95rem] font-[600] text-[#942A27]">Added:</p>
                        <div className="flex flex-col gap-1 mt-1">
                            <p className="text-[0.90rem] text-[#111928]">Option 1</p>
                            <p className="text-[0.90rem] text-[#111928]">Option 2</p>
                            <p className="text-[0.90rem] text-[#111928]">Option 3</p>
                            <p className="text-[0.90rem] text-[#111928]">Option 4</p>
                            <p className="text-[0.90rem] text-[#111928]">Option 5</p>
                        </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
